import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { ReactComponent as LogoVoliaSVG } from 'assets/img/logo-volia-new.svg';
import Button from '../../components/Button';

export const StyledBlock = styled.div`
  margin: 0 ${scaleSize(354)}px;
  text-align: center;
`;

export const StyledLogo = styled(LogoVoliaSVG)`
  height: ${scaleSize(140)}px;
  width: ${scaleSize(428)}px;
  margin-top: ${scaleSize(280)}px;
`;

export const StyledText = styled.div`
  margin: ${scaleSize(64)}px 0;
  font-family: Roboto, sans-serif;
  font-size: ${scaleSize(40)}px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: normal;
  color: ${({ theme }) => theme.mainTextColor};
`;

export const StyledButton = styled(Button)`
  margin-right: 0;
`;
